import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Printer = createReactComponent("Printer", ["svg", defaultAttributes, [["polyline", {
  points: "6 9 6 2 18 2 18 9",
  key: "nud0cz"
}], ["path", {
  d: "M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2",
  key: "vrwuoq"
}], ["rect", {
  x: "6",
  y: "14",
  width: "12",
  height: "8",
  key: "n2kej2"
}]]]);
export default Printer;